import { ApolloProvider } from '@apollo/client'
import { Navigate, Outlet, useParams } from 'react-router-dom'

import { apolloOpponent } from './apollo-opponent'
import { getActiveOpponentKey, setOpponentKey } from './opponent-auth-state'

/**
 * Claims the `:opponentKey` route param as this tab's identity (synchronously
 * during render, so the first Apollo request carries the header) and wraps the
 * Beat-the-Pro routes in the opponent-key Apollo provider. Mirrors
 * PlayerKeyLoader: tab-local key, and a cache wipe when this tab changes key so
 * one pro's audience view can't flash under another's link.
 */
const OpponentKeyLoader = () => {
  const { opponentKey } = useParams<{ opponentKey: string }>()

  if (!opponentKey) return <Navigate to="/" replace />

  const previousKey = getActiveOpponentKey()
  if (previousKey !== opponentKey) {
    setOpponentKey(opponentKey)
    // resetStore, not clearStore, and only on a real switch — see the long
    // note in PlayerKeyLoader (POL-85). A first load has nothing to wipe.
    if (previousKey) {
      apolloOpponent.resetStore().catch(() => {
        /* rejects if a query is mid-flight; the refetch below covers it. */
      })
    }
  }

  return (
    <ApolloProvider client={apolloOpponent} key={opponentKey}>
      <Outlet />
    </ApolloProvider>
  )
}

export default OpponentKeyLoader
